var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4154 21.404L12.6654 2.65396C12.6021 2.53219 12.5065 2.43013 12.3892 2.3589C12.2719 2.28767 12.1373 2.25 12 2.25C11.8627 2.25 11.7281 2.28767 11.6108 2.3589C11.4935 2.43013 11.3979 2.53219 11.3346 2.65396L1.58461 21.404C1.52515 21.5183 1.49615 21.646 1.50041 21.7748C1.50466 21.9036 1.54203 22.0291 1.60889 22.1392C1.67576 22.2494 1.76988 22.3404 1.88218 22.4036C1.99447 22.4668 2.12115 22.5 2.25001 22.5H21.75C21.8789 22.5 22.0055 22.4668 22.1178 22.4036C22.2301 22.3404 22.3242 22.2494 22.3911 22.1392C22.458 22.0291 22.4953 21.9036 22.4996 21.7748C22.5039 21.646 22.4749 21.5183 22.4154 21.404ZM11.1563 8.25001H12.8438V15.75H11.1563V8.25001ZM12 20.25C11.7775 20.25 11.56 20.184 11.375 20.0604C11.19 19.9368 11.0458 19.7611 10.9606 19.5555C10.8755 19.35 10.8532 19.1238 10.8966 18.9055C10.94 18.6873 11.0472 18.4869 11.2045 18.3295C11.3618 18.1722 11.5623 18.065 11.7805 18.0216C11.9988 17.9782 12.225 18.0005 12.4305 18.0856C12.6361 18.1708 12.8118 18.315 12.9354 18.5C13.059 18.685 13.125 18.9025 13.125 19.125C13.125 19.4234 13.0065 19.7095 12.7955 19.9205C12.5845 20.1315 12.2984 20.25 12 20.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFilled);
export default __webpack_public_path__ + "static/media/warning-filled.bad080b98e6f6a8ae3c34c4ab9c96bab.svg";
export { ForwardRef as ReactComponent };